module.exports = "/assets/packs/images/33ef790766cca2a6ff234b90459ed784.png";